var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 2.66666H8.00065C7.29341 2.66666 6.61513 2.94761 6.11503 3.4477C5.61494 3.9478 5.33398 4.62608 5.33398 5.33332V26.6667C5.33398 27.3739 5.61494 28.0522 6.11503 28.5523C6.61513 29.0524 7.29341 29.3333 8.00065 29.3333H24.0007C24.7079 29.3333 25.3862 29.0524 25.8863 28.5523C26.3864 28.0522 26.6673 27.3739 26.6673 26.6667V10.6667L18.6673 2.66666Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 2.66666V9.66666C18.666 10.2189 19.1137 10.6667 19.666 10.6667H26.666",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C10 15.6318 10.2985 15.3333 10.6667 15.3333H21.3333C21.7015 15.3333 22 15.6318 22 16C22 16.3682 21.7015 16.6667 21.3333 16.6667H10.6667C10.2985 16.6667 10 16.3682 10 16Z",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C10 19.6318 10.2985 19.3333 10.6667 19.3333H21.3333C21.7015 19.3333 22 19.6318 22 20C22 20.3682 21.7015 20.6667 21.3333 20.6667H10.6667C10.2985 20.6667 10 20.3682 10 20Z",
    fill: "#8E8CEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 24C10 23.6318 10.2985 23.3333 10.6667 23.3333H21.3333C21.7015 23.3333 22 23.6318 22 24C22 24.3682 21.7015 24.6667 21.3333 24.6667H10.6667C10.2985 24.6667 10 24.3682 10 24Z",
    fill: "#8E8CEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.6667C10 10.2985 10.2985 10 10.6667 10H13.3333C13.7015 10 14 10.2985 14 10.6667C14 11.0349 13.7015 11.3333 13.3333 11.3333H10.6667C10.2985 11.3333 10 11.0349 10 10.6667Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5daceafd0555c21e5c34562c40c5ca3a.svg";
export { ForwardRef as ReactComponent };